import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import Stack from '@mui/material/Stack'

import {
  ANALYTICS_EVENTS,
  useEvent,
  useGlobalCopyStore,
  useRecurringTransactionsStore,
} from '../../../../common'
import { type RepeatingTransaction, Frequency, RepeatingType } from '../../../../core'

import { RecurringRow } from './RecurringRow'
import { AddRecurringTransaction } from './AddRecurringTransaction'
import { RecurringSettingsZeroState } from './RecurringSettingsZeroState'

export const ManageExpenses = observer(() => {
  const { recurring: copy } = useGlobalCopyStore()
  const { detailedRepeatingTransactions } = useRecurringTransactionsStore()
  const { onEvent } = useEvent()

  const onClick = (repeatingTransaction: RepeatingTransaction) => {
    onEvent(ANALYTICS_EVENTS.RECURRING_TRANSACTIONS_CLICK_EXPENSE, {
      repeating_transaction_guid: repeatingTransaction.guid,
    })
  }

  const onAdd = () => {
    onEvent(ANALYTICS_EVENTS.RECURRING_TRANSACTIONS_CLICK_ADD_EXPENSE)
  }

  const filteredTransactions = detailedRepeatingTransactions.filter(
    (rt) =>
      rt.repeating_transaction_type !== RepeatingType.Income &&
      (rt.transactions.length > 0 || rt.recurrence_type === Frequency.EveryYear),
  )

  return (
    <>
      {filteredTransactions.length !== 0 ? (
        <Stack
          sx={{
            height: 'calc(100vh - 109px)',
            maxHeight: 'calc(100vh - 109px)',
          }}
        >
          <Box sx={{ flex: 1, overflow: 'auto' }}>
            <List sx={{ bgcolor: 'background.paper' }}>
              {filteredTransactions.map((rt, index) => (
                <React.Fragment key={rt.guid}>
                  <RecurringRow onClick={onClick} repeatingTransaction={rt} />
                  <Divider
                    variant={index < filteredTransactions.length - 1 ? 'inset' : 'fullWidth'}
                  />
                </React.Fragment>
              ))}
            </List>
          </Box>
          <Box>
            <Divider />
            <Box
              sx={{
                alignContent: 'center',
                bgcolor: 'background.paper',
                justifyContent: 'flex-end',
                px: 24,
                py: 12,
                textAlign: 'right',
              }}
            >
              <AddRecurringTransaction label={copy.add_expense} onAddRecurringTransaction={onAdd} />
            </Box>
          </Box>
        </Stack>
      ) : (
        <RecurringSettingsZeroState zeroStateFor="expenses" />
      )}
    </>
  )
})
